import { Handle, Position } from "@xyflow/react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import AddEditCallToActionModal from "./AddEditCallToActionModal";

const ViewCallToActionBox = ({
  data,
  onNewStep,
  totalSteps,
  onDelete,
  steps = [],
  onEditContent,
}) => {
  const { part, branchOption } = data || [];
  const callToAction = part?.callToAction || [];
  const [showCtaAddEditPopup, setShowCtaAddEditPopup] = useState(false);

  const handleAddEditCTA = () => {
    setShowCtaAddEditPopup(true);
  };

  return (
    <div
      className={
        !branchOption && data?.stepIndex + 1 === totalSteps
          ? "last-step view-poll-box"
          : "view-poll-box"
      }
    >
      <Handle type="target" position={Position.Top} id="top-handle" />
      <Handle type="target" position={Position.Left} id="left-handle" />

      <div
        style={{
          marginRight: "0px",
          backgroundColor: "transparent",
          display: "flex",
          gap: "50px",
        }}
        key={callToAction.id}
      >
        <div style={{ width: "350px" }}>
          {branchOption ? (
            <>
              <div className="user-option-selected-container">
                <div className="user-option-header">If user select</div>
                <span
                  className="remove-button"
                  onClick={() => onDelete(data.branchId, "branch")}
                >
                  Remove
                </span>
              </div>
              <div className="option-container">{branchOption}</div>
            </>
          ) : (
            <div className="step-number">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">Step {data.order}</span>
                <span
                  className="customLabel remove-button"
                  onClick={() => handleAddEditCTA()}
                >
                  Edit
                </span>
                <span
                  className="customLabel remove-button"
                  onClick={() => onDelete(data.id, "step")}
                >
                  Remove
                </span>
              </div>
            </div>
          )}
          <div
            className="form-box"
            style={{
              backgroundColor: callToAction.styleBackground.color,
              backgroundImage: callToAction.backgroundImage
                ? `url(https://cdn.sided.co/${callToAction.backgroundImage})`
                : "none",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            {callToAction.ctaImage != null && (
              <div className="form-box-image">
                <img
                  src={`https://cdn.sided.co/${callToAction.ctaImage}`}
                  alt="content"
                />
              </div>
            )}
            <div
              className="form-box-title"
              style={{
                color: callToAction.styleTitle.color,
                fontSize: callToAction.styleTitle.fontSize,
                overflow: "hidden",
                Overflow: "ellipsis",
                eSpace: "nowrap",
                maxWidth: "100%",
              }}
            >
              {callToAction.title}
            </div>
            <div
              className="form-box-description"
              style={{
                color: callToAction.styleDescription.color,
                fontSize: callToAction.styleDescription.fontSize,
                overflow: "hidden",
                Overflow: "ellipsis",
                eSpace: "nowrap",
                maxWidth: "100%",
              }}
            >
              {callToAction.description}
            </div>

            <button
              disabled
              className="form-box-submit blue-button"
              style={{
                backgroundColor: callToAction.styleButton.color,
                color: callToAction.styleButton.textColor,
                fontSize: callToAction.styleButton.fontSize,
              }}
            >
              {callToAction.buttonText || "Submit"}
            </button>
          </div>
        </div>
        {showCtaAddEditPopup && (
          <AddEditCallToActionModal
            show={showCtaAddEditPopup}
            onClose={() => {
              setShowCtaAddEditPopup(false);
              onEditContent(true);
            }}
            contentCallToActionId={callToAction.id}
          />
        )}
        {!branchOption && data?.stepIndex + 1 === totalSteps && (
          <div>
            <div className="add-step-button-container">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">
                  Add Step {data.order + 1}
                </span>
              </div>
            </div>
            <div className="add-step-branch-group">
              <div className="d-flex justify-content-center border align-items-center add-step-container">
                <Button
                  onClick={() => onNewStep(data)}
                  className="add-step-button"
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} id="bottom-handle" />
      <Handle type="source" position={Position.Right} id="right-handle" />
    </div>
  );
};

export default ViewCallToActionBox;
